import { MultiMedia } from './hoardings/multiMedia';

export class SibDocument extends MultiMedia {
    type: string;
}